import { Controller, useFormContext } from "react-hook-form";
import useTranslations from "../core/i18n/useTranslations";
import {
  ITreeData,
  CustomDropdown,
} from "../ui-lib/components/Hierarchy/CustomTreeDropdown/CustomDropdown";

export const OrganisationPicker = ({
  name,
  label,
  required,
  disabled,
}: {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
}) => {
  const {
    control,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useFormContext();

  const organisationId = watch("organizationId");

  const t = useTranslations();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required,
      }}
      render={({ field }) => (
        <CustomDropdown
          fullWidth
          label={label}
          disabled={disabled}
          placeholder={t("Common:organisation")}
          customerFilter={{ customers: organisationId.toString() }}
          onSelectSignle={(data?: ITreeData) => {
            const customerId = data?.key as number | undefined;
            setValue(field.name, customerId);
            trigger(field.name);
          }}
          validationError={
            errors.CustomerId && t("Errors:input_field_required")
          }
        />
      )}
    />
  );
};
